<div>
  <table mat-table [dataSource]="dataSource">
    <caption></caption>
    <ng-container matColumnDef="{{getHeaderName('reportName')}}">
      <th mat-header-cell scope="col" *matHeaderCellDef>Report Name</th>
      <td class="OverflowControl" mat-cell *matCellDef="let element">
        @if (downloadCheck(element,dataSource.filteredData.indexOf(element))
          && downloadReportCheck(dataSource.filteredData.indexOf(element))) {
          <a (click)="downloadFile(element)"
          class="simple-link pointer" matTooltip="Click to download report " [ngClass]="{'isAbnormal': element.isAbnormal}">{{getName(element.reportName)}}</a>
        }
        @if (!(downloadCheck(element,dataSource.filteredData.indexOf(element))
          && downloadReportCheck(dataSource.filteredData.indexOf(element)))) {
          <span
          class="btn__grey" [ngClass]="{'isAbnormal': element.isAbnormal}">{{getName(element.reportName)}}</span>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="{{getHeaderName('reportType')}}">
      <th mat-header-cell scope="col" *matHeaderCellDef>Report Type</th>
      <td class="OverflowControl" mat-cell *matCellDef="let element" [ngClass]="{'isAbnormal': element.isAbnormal}">
        <span>{{element.reportType}}</span>
      </td>
    </ng-container>
    <ng-container matColumnDef="{{getHeaderName('generatedOn')}}">
      <th mat-header-cell scope="col" *matHeaderCellDef class="padding-right">Generated On</th>
      <td mat-cell *matCellDef="let element" class="padding-right" [ngClass]="{'isAbnormal': element.isAbnormal}"> {{element.generatedOn | date: 'MM/dd/yyyy hh:mm:ss a'}} </td>
    </ng-container>
    <ng-container matColumnDef="{{getHeaderName('share')}}">
      <th mat-header-cell scope="col" [hidden]="hideShareBtn" *matHeaderCellDef>Share</th>
      <td mat-cell [hidden]="hideShareBtn" *matCellDef="let element">
        @if (downloadCheck(element,dataSource.filteredData.indexOf(element))) {
          <button mat-icon-button
            (click)="openShareReportDialog(element)" tabindex="-1">
            <mat-icon
            matTooltip="Click to share report">share</mat-icon>
          </button>
        }
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
